module.exports = {

    /**
     * Helper method for making POST HTTP requests.
     */
    post (uri, form) {
        return App.sendForm("post", uri, form);
    },

    postMultipartForm (uri, form) {
        return App.sendMultipartForm("post", uri, form);
    },

    /**
     * Helper method for making PUT HTTP requests.
     */
    put (uri, form) {
        return App.sendForm("put", uri, form);
    },

    /**
     * Helper method for making PATCH HTTP requests.
     */
    patch (uri, form) {
        return App.sendForm("patch", uri, form);
    },

    /**
     * Helper method for making DELETE HTTP requests.
     */
    delete (uri, form) {
        return App.sendForm("delete", uri, form);
    },

    /**
     * Send the form to the back-end server.
     *
     * This function will clear old errors, update "busy" status, etc.
     */
    sendForm (method, uri, form) {
        return new Promise((resolve, reject) => {
            form.startProcessing();

            axios[method](uri, JSON.parse(JSON.stringify(form)))
            .then(response => {

                form.finishProcessing();

                resolve(response.data);
            })
            .catch(errors => {

                if (errors.response !== undefined
                    && errors.response.data !== undefined
                    && errors.response.data.errors !== undefined) {
                    form.setErrors(errors.response.data.errors);
                } else {
                    form.resetStatus();
                }

                reject(errors.response.data);

            });
        });
    },

    /**
     * Send the form as multipart to the back-end server.
     *
     * This function will clear old errors, update "busy" status, etc.
     */
    sendMultipartForm (method, uri, form) {
        return new Promise((resolve, reject) => {
            form.startProcessing();

            let formData = this.convertModelToFormData(form, new FormData());

            axios[method](uri, formData, {
                headers: {
                    "content-type": "multipart/form-data",
                }
            })
            .then(response => {
                form.finishProcessing();

                resolve(response.data);
            })
            .catch(errors => {

                if (errors.response !== undefined) {
                    form.setErrors(errors.response.data.errors);
                    form.requestStatus = errors.response.status;
                } else {
                    form.resetStatus();
                }

                if (errors.response){
                    reject(errors.response.data);
                }

                reject(errors);
            });
        });
    },

    convertModelToFormData (model, form, namespace = "") {
        let formData = form;

        if (model instanceof File) {
            formData.append(namespace, model);
            return formData;
        }

        // Array recursion could end up with the model being a simple property like an int that wont go into the for loop below
        if (!(model instanceof Object) && !(model instanceof Array) && !(model instanceof Boolean)) {
            formData.append(namespace, model);
        }

        for (let propertyName in model) {
            if (!model.hasOwnProperty(propertyName) || model[propertyName] == null) continue;
            let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

            if (model[propertyName] instanceof Array) {
                model[propertyName].forEach((element, index) => {
                    const tempFormKey = `${formKey}[${index}]`;
                    formData = this.convertModelToFormData(element, formData, tempFormKey);
                });
            } else if (typeof model[propertyName] === "object" && !(model[propertyName] instanceof File)) {
                formData = this.convertModelToFormData(model[propertyName], formData, formKey);
            } else if (typeof model[propertyName] === "boolean") {
                formData.append(formKey, model[propertyName] ? 1 : 0);
            } else {
                formData.append(formKey, model[propertyName]);
            }
        }

        return formData;
    },
};
